import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { getListBobotKomponenPenilaian } from "@/services/getData"
import {
  BobotKomponenKaryatulis,
  BobotKomponenPenilaian,
  DataBerkas,
  DataNilaiVerifikasiPasca,
  DataPendaftaran,
  Option,
  VerBerkasPascaKelompokDetail,
} from "@/types"
import { useEffect, useState } from "react"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
// import RowA from "./RowA";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import api from "@/lib/axios"
import { AxiosError } from "axios"
import { Loader2 } from "lucide-react"
import toast from "react-hot-toast"
import { FaArrowLeftLong, FaFaceGrinBeam } from "react-icons/fa6"
import SkeletonTable from "@/components/SkeletonTable"

type ValuePenilaian = {
  id_data_pendaftaran?: string
  id_ref_komponen_penilaian_pasca: string
  jumlah_lokal?: number | null
  jumlah_nasional?: number | null
  jumlah_internasional?: number | null
  skor?: number | null
}

// const listParent = [
//   {
//     kode: "A",
//     nama_ref_parent_komponen: "Administrasi",
//     keterangan: "Data Kelengkapan Administrasi Program Studi Lulusan Terakhir",
//     list_komponen_penilaian: [
//       {
//         nama_komponen: "Program Studi",
//         value: "Ilmu Komputer (S1)",
//         skor: "10",
//         jumlah_lokal: "",
//         jumlah_nasional: "",
//         jumlah_international: "1",
//       },
//       {
//         nama_komponen: "Lulusan dari PT terakreditasi",
//         value: "A",
//         skor: "10",
//         jumlah_lokal: "",
//         jumlah_nasional: "",
//         jumlah_international: "1",
//       },
//     ],
//     skor_tpa: "",
//     skor_tkb: "",
//   },
//   {
//     kode: "B",
//     nama_ref_parent_komponen: "Karya Tulis, dll",
//     keterangan: "KARYA TULIS, dan Lain-Lain",
//     list_komponen_penilaian: [
//       {
//         nama_komponen: "Artikel dalam Jurnal",
//         value: "",
//         skor: "",
//         jumlah_lokal: "",
//         jumlah_nasional: "",
//         jumlah_international: "1",
//       },
//       {
//         nama_komponen: "Karya Ilmiah Lainnya ",
//         value: "Ilmu Komputer (S1)",
//         skor: "10",
//         jumlah_lokal: "",
//         jumlah_nasional: "",
//         jumlah_international: "1",
//       },
//     ],
//     skor_tpa: "",
//     skor_tkb: "",
//   },
//   {
//     kode: "C",
//     nama_ref_parent_komponen: "Hasil Test Elearning",
//     keterangan: "Hasil Test TPA dan TKB di Elearning",
//     list_komponen_penilaian: [],
//     skor_tpa: "10",
//     skor_tkb: "10",
//   },
// ];

const getListDataPenilaian = async (id_data_pendaftaran: string) => {
  const response = await api.get(
    `/verifikator-pasca/data-nilai-verifikasi?id_data_pendaftaran=${id_data_pendaftaran}`
  )
  return response.data?.data
}

const saveNilai = async (data: ValuePenilaian) => {
  const response = await api.post(`/verifikator-pasca/save-nilai`, data)
  return response.data
}

const saveNilaiMultiple = async ({
  id_data_pendaftaran,
  list_komponen_penilaian,
}: {
  id_data_pendaftaran: string
  list_komponen_penilaian: ValuePenilaian[]
}) => {
  const response = await api.post(`/verifikator-pasca/save-nilai-multiple`, {
    id_data_pendaftaran,
    list_komponen_penilaian,
  })
  return response.data
}

export default function FormPenilaian({
  dataPeserta,
}: {
  dataPeserta: VerBerkasPascaKelompokDetail
}) {
  const [showPdf, setShowPdf] = useState(false)
  const [selectedBerkas, setSelectedBerkas] = useState<DataBerkas | null>(null)
  const [selectedDataPendaftaran] = useState<DataPendaftaran | null>(
    dataPeserta?.data_pendaftaran
  )
  const [selectedOptions, setSelectedOptions] = useState<
    Record<number, (Option & { bobot: number }) | null>
  >({})
  const [savingDataNilaiVerifikasi, setSavingDataNilaiVerifikasi] =
    useState<DataNilaiVerifikasiPasca | null>(null)
  const [jumlahData, setJumlahData] = useState<
    Record<
      number,
      {
        id_ref_komponen_penilaian_pasca: string
        jumlah_lokal: number
        jumlah_nasional: number
        jumlah_internasional: number
      }
    >
  >({})

  const { data: listBobotKomponenPenilaian } = useQuery({
    queryKey: ["listBobotKomponenPenilaian"],
    queryFn: getListBobotKomponenPenilaian,
    select: (data) =>
      data?.map((item: BobotKomponenPenilaian) => {
        return {
          label: `${item.kriteria} | Bobot: ${item.bobot}`,
          value: item.id_ref_bobot_komponen_penilaian_pasca,
          idRefKomponenPenilaianPasca: item.id_ref_komponen_penilaian_pasca,
          bobot: item.bobot,
        }
      }),
  })

  const { data: listDataPenilaian, isPending: isPendingListDataPenilaian } =
    useQuery({
      queryKey: ["listDataPenilaian"],
      queryFn: () =>
        getListDataPenilaian(
          String(selectedDataPendaftaran?.id_data_pendaftaran)
        ),
      enabled: !!selectedDataPendaftaran,
    })

  const queryClient = useQueryClient()

  const { mutate, isPending } = useMutation({
    mutationFn: saveNilai,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["listPesertaVerifikasi"] })
      queryClient.invalidateQueries({
        queryKey: ["listDataPenilaian"],
      })
      toast.success(data?.message || "Success.")
      setSavingDataNilaiVerifikasi(null)
    },
    onError: (error: AxiosError) => {
      const err = error as AxiosError<{ message?: string }>
      toast.error(
        err?.response?.data?.message || "An unexpected error occurred."
      )
      setSavingDataNilaiVerifikasi(null)
    },
  })

  const { mutate: mutateSaveMultiple, isPending: isPendingSaveMultiple } =
    useMutation({
      mutationFn: saveNilaiMultiple,
      onSuccess: (data) => {
        queryClient.invalidateQueries({ queryKey: ["listPesertaVerifikasi"] })
        queryClient.invalidateQueries({
          queryKey: ["listDataPenilaian"],
        })
        toast.success(data?.message || "Success.")
        setSavingDataNilaiVerifikasi(null)
      },
      onError: (error: AxiosError) => {
        const err = error as AxiosError<{ message?: string }>
        toast.error(
          err?.response?.data?.message || "An unexpected error occurred."
        )
        setSavingDataNilaiVerifikasi(null)
      },
    })

  const handleSelectChange = (
    index: number,
    selected: (Option & { bobot: number }) | null
  ) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [index]: selected,
    }))
  }

  const handleInputChange = (
    id_ref_komponen_penilaian_pasca: string,
    value: number,
    field: "jumlah_lokal" | "jumlah_nasional" | "jumlah_internasional",
    index: number
  ) => {
    setJumlahData((prev) => {
      const updated = { ...prev } // Clone current state

      if (!updated[index]) {
        // Jika belum ada, inisialisasi nilai default
        updated[index] = {
          id_ref_komponen_penilaian_pasca: "",
          jumlah_lokal: 0,
          jumlah_nasional: 0,
          jumlah_internasional: 0,
        }
      }

      // Update field tertentu
      updated[index] = {
        ...updated[index],
        id_ref_komponen_penilaian_pasca,
        [field]: value,
      }

      return updated // Return state yang telah diperbarui
    })
  }

  const getBobotPengali = (
    listDataNilaiVerifikasiPasca: DataNilaiVerifikasiPasca[],
    key: "Lokal" | "Nasional" | "Internasional"
  ) => {
    return (
      listDataNilaiVerifikasiPasca
        .find((item: DataNilaiVerifikasiPasca) =>
          item.komponen_penilaian?.parent_komponen?.bobot_komponen_karyatulis?.find(
            (bobot) => bobot.tingkat?.startsWith(key)
          )
        )
        ?.komponen_penilaian?.parent_komponen?.bobot_komponen_karyatulis?.find(
          (bobot: BobotKomponenKaryatulis) => bobot.tingkat?.startsWith(key)
        )?.bobot ?? 0
    )
  }

  const handleSave = (
    dataNilaiVerifikasi: DataNilaiVerifikasiPasca,
    index: number,
    key: "A" | "B"
  ) => {
    setSavingDataNilaiVerifikasi(dataNilaiVerifikasi)

    const bobotLokal =
      listDataPenilaian[key]
        .find((item: DataNilaiVerifikasiPasca) =>
          item.komponen_penilaian?.parent_komponen?.bobot_komponen_karyatulis?.find(
            (bobot) => bobot.tingkat?.startsWith("Lokal")
          )
        )
        ?.komponen_penilaian?.parent_komponen?.bobot_komponen_karyatulis?.find(
          (bobot: BobotKomponenKaryatulis) => bobot.tingkat?.startsWith("Lokal")
        )?.bobot ?? 0

    const bobotNasional =
      listDataPenilaian[key]
        .find((item: DataNilaiVerifikasiPasca) =>
          item.komponen_penilaian?.parent_komponen?.bobot_komponen_karyatulis?.find(
            (bobot) => bobot.tingkat?.startsWith("Nasional")
          )
        )
        ?.komponen_penilaian?.parent_komponen?.bobot_komponen_karyatulis?.find(
          (bobot: BobotKomponenKaryatulis) =>
            bobot.tingkat?.startsWith("Nasional")
        )?.bobot ?? 0

    const bobotInternasional =
      listDataPenilaian[key]
        .find((item: DataNilaiVerifikasiPasca) =>
          item.komponen_penilaian?.parent_komponen?.bobot_komponen_karyatulis?.find(
            (bobot) => bobot.tingkat?.startsWith("Internasional")
          )
        )
        ?.komponen_penilaian?.parent_komponen?.bobot_komponen_karyatulis?.find(
          (bobot: BobotKomponenKaryatulis) =>
            bobot.tingkat?.startsWith("Internasional")
        )?.bobot ?? 0

    const skorLokal = (jumlahData[index]?.jumlah_lokal ?? 0) * bobotLokal
    const skorNasional =
      (jumlahData[index]?.jumlah_nasional ?? 0) * bobotNasional
    const skorInternasional =
      (jumlahData[index]?.jumlah_internasional ?? 0) * bobotInternasional

    const data = {
      id_data_pendaftaran: String(
        dataPeserta.data_pendaftaran.id_data_pendaftaran
      ),
      id_ref_komponen_penilaian_pasca:
        dataNilaiVerifikasi?.id_ref_komponen_penilaian_pasca,
      jumlah_lokal: key == "B" ? jumlahData[index].jumlah_lokal : null,
      jumlah_nasional: key == "B" ? jumlahData[index].jumlah_nasional : null,
      jumlah_internasional:
        key == "B" ? jumlahData[index].jumlah_internasional : null,
      skor:
        key == "A"
          ? selectedOptions[index]?.bobot
          : skorLokal + skorNasional + skorInternasional,
    }

    mutate(data)
  }

  const handleSaveMultiple = (key: "A" | "B") => {
    if (!selectedOptions) return

    let listKomponenPenilaian: ValuePenilaian[] = []

    if (key === "A") {
      listKomponenPenilaian = Object.keys(selectedOptions)?.map(
        (keyOption: string) => {
          return {
            id_ref_komponen_penilaian_pasca:
              String(
                selectedOptions[Number(keyOption) as number]
                  ?.idRefKomponenPenilaianPasca
              ) || "",
            jumlah_lokal: null,
            jumlah_nasional: null,
            jumlah_internasional: null,
            skor: selectedOptions[Number(keyOption) as number]?.bobot,
          }
        }
      )
    }

    if (key === "B") {
      const bobotLokal = getBobotPengali(listDataPenilaian[key], "Lokal")
      const bobotNasional = getBobotPengali(listDataPenilaian[key], "Nasional")
      const bobotInternasional = getBobotPengali(
        listDataPenilaian[key],
        "Internasional"
      )

      listKomponenPenilaian = Object.keys(jumlahData)?.map((index: string) => {
        const skorLokal =
          (jumlahData[Number(index) as number]?.jumlah_lokal ?? 0) * bobotLokal
        const skorNasional =
          (jumlahData[Number(index) as number]?.jumlah_nasional ?? 0) *
          bobotNasional
        const skorInternasional =
          (jumlahData[Number(index) as number]?.jumlah_internasional ?? 0) *
          bobotInternasional

        return {
          id_ref_komponen_penilaian_pasca:
            String(
              jumlahData[Number(index) as number]
                ?.id_ref_komponen_penilaian_pasca
            ) || "",
          jumlah_lokal: jumlahData[Number(index) as number]?.jumlah_lokal,
          jumlah_nasional: jumlahData[Number(index) as number]?.jumlah_nasional,
          jumlah_internasional:
            jumlahData[Number(index) as number]?.jumlah_internasional,
          skor: skorLokal + skorNasional + skorInternasional,
        }
      })
    }

    const finalListKomponenPenilaian = listKomponenPenilaian?.filter(
      (penilaian) => {
        return penilaian.id_ref_komponen_penilaian_pasca != "undefined"
      }
    )

    const data: {
      id_data_pendaftaran: string
      list_komponen_penilaian: ValuePenilaian[]
    } = {
      id_data_pendaftaran: String(dataPeserta.id_data_pendaftaran) || "",
      list_komponen_penilaian: finalListKomponenPenilaian,
    }

    mutateSaveMultiple(data)
  }

  useEffect(() => {
    if (!listDataPenilaian) return

    Object.keys(listDataPenilaian)?.map((key) => {
      return listDataPenilaian[key]?.map(
        (dataNilaiVerifikasi: DataNilaiVerifikasiPasca, index: number) => {
          if (key == "A") {
            const filteredListOptions = listBobotKomponenPenilaian?.filter(
              (
                optionBobot: Option & {
                  idRefKomponenPenilaianPasca: string
                }
              ) => {
                return (
                  optionBobot.idRefKomponenPenilaianPasca ==
                  dataNilaiVerifikasi.id_ref_komponen_penilaian_pasca
                )
              }
            )

            const selected = filteredListOptions?.find(
              (
                option: Option & {
                  bobot: number
                }
              ) => option.bobot == dataNilaiVerifikasi.skor
            )

            handleSelectChange(index, selected || null)
          }

          if (key == "B") {
            handleInputChange(
              dataNilaiVerifikasi.id_ref_komponen_penilaian_pasca,
              dataNilaiVerifikasi.jumlah_lokal,
              "jumlah_lokal",
              index
            )
            handleInputChange(
              dataNilaiVerifikasi.id_ref_komponen_penilaian_pasca,
              dataNilaiVerifikasi.jumlah_nasional,
              "jumlah_nasional",
              index
            )
            handleInputChange(
              dataNilaiVerifikasi.id_ref_komponen_penilaian_pasca,
              dataNilaiVerifikasi.jumlah_internasional,
              "jumlah_internasional",
              index
            )
          }
        }
      )
    })
  }, [listDataPenilaian])

  if (isPendingListDataPenilaian) return <SkeletonTable />

  return (
    <div>
      <div>
        <h1 className="text-xl font-bold">
          Data Pendaftaran |{" "}
          <span className="text-primary">
            {dataPeserta.data_pendaftaran.nomor_pendaftaran}
          </span>
        </h1>
      </div>

      <div className="relative p-5 flex lg:flex-row flex-col gap-3 h-[80vh] overflow-auto">
        <section className="p-5 lg:w-[25%] border rounded-xl">
          <div className="mb-5">
            <table>
              <thead>
                <tr>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="px-2 py-1 font-semibold">Nomor Pendaftaran</td>
                  <td className="px-2 py-1">:</td>
                  <td className="px-2 py-1">
                    {dataPeserta.data_pendaftaran.nomor_pendaftaran}
                  </td>
                </tr>
                <tr>
                  <td className="px-2 py-1 font-semibold">Nama</td>
                  <td className="px-2 py-1">:</td>
                  <td className="px-2 py-1">
                    {dataPeserta.data_pendaftaran.data_siswa?.nama_lengkap}
                  </td>
                </tr>
                <tr>
                  <td className="px-2 py-1 font-semibold">Prodi Pilihan</td>
                  <td className="px-2 py-1">:</td>
                  <td className="px-2 py-1">
                    {dataPeserta.data_pendaftaran.data_pilihan_prodi &&
                      dataPeserta.data_pendaftaran.data_pilihan_prodi[0]
                        ?.unitkerja?.nama}
                  </td>
                </tr>
                <tr>
                  <td className="px-2 py-1 font-semibold">Asal PT</td>
                  <td className="px-2 py-1">:</td>
                  <td className="px-2 py-1">
                    {
                      dataPeserta.data_pendaftaran.ref_asal_pt
                        ?.nama_perguruan_tinggi
                    }
                  </td>
                </tr>
                <tr>
                  <td className="px-2 py-1 font-semibold">Akreditasi PT</td>
                  <td className="px-2 py-1">:</td>
                  <td className="px-2 py-1">
                    {dataPeserta.data_pendaftaran.akreditasi_pt_asal}
                  </td>
                </tr>
                <tr>
                  <td className="px-2 py-1 font-semibold">Asal Prodi</td>
                  <td className="px-2 py-1">:</td>
                  <td className="px-2 py-1">
                    {
                      dataPeserta.data_pendaftaran.ref_asal_prodi
                        ?.nama_program_studi
                    }
                  </td>
                </tr>
                <tr>
                  <td className="px-2 py-1 font-semibold">Akreditasi Prodi</td>
                  <td className="px-2 py-1">:</td>
                  <td className="px-2 py-1">
                    {dataPeserta.data_pendaftaran.akreditasi_prodi_asal}
                  </td>
                </tr>
                <tr>
                  <td className="px-2 py-1 font-semibold">IPK</td>
                  <td className="px-2 py-1">:</td>
                  <td className="px-2 py-1">
                    {dataPeserta.data_pendaftaran.nilai_IPK}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="border rounded-xl">
            <table className="table-auto w-full border-collapse border rounded-xl overflow-hidden">
              <thead>
                <tr className="bg-secondary">
                  <th className="px-2 py-1 font-semibold border">No</th>
                  <th className="px-2 py-1 font-semibold border">Berkas</th>
                  <th className="px-2 py-1 font-semibold border"></th>
                </tr>
              </thead>
              <tbody>
                {dataPeserta.data_pendaftaran?.data_berkas.length > 0
                  ? dataPeserta.data_pendaftaran.data_berkas.map(
                      (berkas, index) => {
                        return (
                          <tr key={berkas.id_data_berkas_siswa}>
                            <td className="px-2 py-1 border text-center">
                              {index + 1}
                            </td>
                            <td className="px-2 py-1 border text-center">
                              {
                                berkas.sys_berkas?.jenis_berkas
                                  ?.nama_jenis_berkas
                              }
                            </td>
                            <td className="px-2 py-1 border text-center">
                              <Button
                                variant={
                                  selectedBerkas?.id_data_berkas_siswa ==
                                  berkas.id_data_berkas_siswa
                                    ? "default"
                                    : "outline"
                                }
                                onClick={() => {
                                  setSelectedBerkas(berkas)
                                  setShowPdf(true)
                                }}
                              >
                                {selectedBerkas?.id_data_berkas_siswa ==
                                berkas.id_data_berkas_siswa
                                  ? "Sedang dilihat"
                                  : "Lihat"}
                              </Button>
                            </td>
                          </tr>
                        )
                      }
                    )
                  : "Data berkas tidak ditemukan..."}
              </tbody>
            </table>
          </div>
        </section>
        <section className="relative overflow-auto flex-1 border rounded-xl">
          <div className="p-5 pb-0 flex items-center gap-5">
            <div>
              <div className="border rounded-full flex overflow-hidden">
                <div
                  className={`py-2 px-3 font-semibold rounded-full ${
                    showPdf
                      ? "bg-black text-white"
                      : "hover:bg-secondary hover:rounded-l-none cursor-pointer"
                  }`}
                  onClick={() => setShowPdf(true)}
                >
                  Berkas
                </div>
                <div
                  className={`py-2 px-3 font-semibold rounded-full ${
                    !showPdf
                      ? "bg-black text-white"
                      : "hover:bg-secondary hover:rounded-l-none cursor-pointer"
                  }`}
                  onClick={() => {
                    setShowPdf(false)
                  }}
                >
                  Komponen Penilaian
                </div>
              </div>
            </div>
            <div className="text-xl font-semibold">
              {showPdf ? (
                <>
                  Berkas
                  <span className="text-primary">
                    {" "}
                    {
                      selectedBerkas?.sys_berkas?.jenis_berkas
                        ?.nama_jenis_berkas
                    }
                  </span>
                </>
              ) : (
                <>
                  Komponen <span className="text-primary">Penilaian</span>
                </>
              )}
            </div>
          </div>
          {showPdf ? (
            selectedBerkas ? (
              <div>
                <iframe
                  src={selectedBerkas?.path_berkas || ""}
                  className="p-5 absolute w-full h-full"
                />
              </div>
            ) : (
              <div className="h-[60vh] flex justify-center items-center">
                <div>
                  <FaFaceGrinBeam size={50} className="mb-5 mx-auto" />
                  <div className="text-2xl font-bold flex items-center gap-3">
                    <FaArrowLeftLong />
                    Pilih berkas untuk dilihat
                  </div>
                </div>
              </div>
            )
          ) : (
            <div className="p-5 flex flex-col gap-y-5">
              {listDataPenilaian
                ? Object.keys(listDataPenilaian).map((key) => {
                    const dataPenilaian: DataNilaiVerifikasiPasca =
                      listDataPenilaian[key].find(
                        (item: DataNilaiVerifikasiPasca) => {
                          return (
                            item.komponen_penilaian?.parent_komponen?.kode ==
                            key
                          )
                        }
                      )

                    return (
                      <div key={key} className="border rounded-xl">
                        <table className="table-auto w-full border-collapse border rounded-xl overflow-hidden">
                          <thead>
                            <tr className="bg-secondary">
                              <th className="px-2 py-1 font-semibold border w-[5rem]">
                                {key}
                              </th>
                              <th
                                className="px-2 py-1 font-semibold border"
                                colSpan={5}
                              >
                                {
                                  dataPenilaian?.komponen_penilaian
                                    ?.parent_komponen?.nama_ref_parent_komponen
                                }
                              </th>

                              <th className="px-2 py-1 font-semibold border w-[10rem]">
                                Tombol Aksi
                              </th>
                            </tr>
                          </thead>

                          {key === "A" ? (
                            <>
                              <tbody>
                                <tr>
                                  <td className="px-2 py-1 border text-center font-medium">
                                    No
                                  </td>
                                  <td className="px-2 py-1 border font-medium">
                                    Komponen
                                  </td>
                                  {/* <td
                                      className="px-2 py-1 border font-medium"
                                      colSpan={3}
                                    >
                                      Data Kelengkapan Administrasi S1 / S2
                                    </td> */}
                                  <td
                                    className="px-2 py-1 border text-center font-medium w-[30%]"
                                    colSpan={2}
                                  >
                                    Kriteria
                                  </td>
                                  <td
                                    className="px-2 py-1 border text-center font-medium"
                                    colSpan={2}
                                  >
                                    Skor Penilai (dalam skala 10)
                                  </td>
                                </tr>
                                {listDataPenilaian[key]?.map(
                                  (
                                    dataNilaiVerifikasi: DataNilaiVerifikasiPasca,
                                    index: number
                                  ) => {
                                    const filteredListBobotKomponenPenilaian =
                                      listBobotKomponenPenilaian?.filter(
                                        (
                                          optionBobot: Option & {
                                            idRefKomponenPenilaianPasca: string
                                          }
                                        ) => {
                                          return (
                                            optionBobot.idRefKomponenPenilaianPasca ==
                                            dataNilaiVerifikasi.id_ref_komponen_penilaian_pasca
                                          )
                                        }
                                      )

                                    const selected = selectedOptions[index]
                                      ?.bobot
                                      ? filteredListBobotKomponenPenilaian?.find(
                                          (
                                            option: Option & {
                                              bobot: number
                                            }
                                          ) =>
                                            selectedOptions[index]?.bobot ==
                                            option.bobot
                                        )
                                      : null

                                    const isSaving =
                                      isPending &&
                                      savingDataNilaiVerifikasi?.id_ref_komponen_penilaian_pasca ==
                                        dataNilaiVerifikasi.id_ref_komponen_penilaian_pasca

                                    return (
                                      <tr key={index}>
                                        <td className="px-2 py-1 border text-center">
                                          {index + 1}
                                        </td>
                                        <td className="px-2 py-1 border">
                                          {
                                            dataNilaiVerifikasi
                                              .komponen_penilaian?.nama_komponen
                                          }
                                        </td>
                                        <td
                                          className="px-2 py-1 border text-center"
                                          colSpan={2}
                                        >
                                          <Select
                                            value={
                                              selectedOptions[index]
                                                ? `${selectedOptions[index]?.value}`
                                                : undefined
                                            }
                                            onValueChange={(value) => {
                                              const selected =
                                                filteredListBobotKomponenPenilaian?.find(
                                                  (
                                                    option: Option & {
                                                      bobot: number
                                                    }
                                                  ) => option.value == value
                                                )
                                              handleSelectChange(
                                                index,
                                                selected || null
                                              )
                                            }}
                                          >
                                            <SelectTrigger>
                                              <SelectValue
                                                placeholder={"Pilih Kriteria"}
                                              >
                                                {selected && selected?.label}
                                              </SelectValue>
                                            </SelectTrigger>
                                            <SelectContent>
                                              {filteredListBobotKomponenPenilaian?.map(
                                                (
                                                  option: Option & {
                                                    bobot: number
                                                  },
                                                  index: number
                                                ) => (
                                                  <SelectItem
                                                    key={index}
                                                    value={`${option.value}`}
                                                  >
                                                    {option.label}
                                                  </SelectItem>
                                                )
                                              )}
                                            </SelectContent>
                                          </Select>
                                        </td>
                                        <td
                                          className="px-2 py-1 border text-center"
                                          colSpan={2}
                                        >
                                          {dataNilaiVerifikasi?.skor}
                                        </td>
                                        <td className="px-2 py-1 border text-center">
                                          <Button
                                            variant={"outline"}
                                            disabled={isSaving}
                                            onClick={() =>
                                              handleSave(
                                                dataNilaiVerifikasi,
                                                index,
                                                "A"
                                              )
                                            }
                                          >
                                            {isSaving ? (
                                              <>
                                                <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                                                Processing...
                                              </>
                                            ) : (
                                              "Simpan"
                                            )}
                                          </Button>
                                        </td>
                                      </tr>
                                    )
                                  }
                                )}
                              </tbody>

                              <tfoot>
                                <tr>
                                  <td
                                    className="px-2 py-1 border text-center"
                                    colSpan={5}
                                  >
                                    Total
                                  </td>
                                  <td className="px-2 py-1 border text-center">
                                    {listDataPenilaian[key]?.reduce(
                                      (
                                        total: number,
                                        dataNilaiVerifikasi: DataNilaiVerifikasiPasca
                                      ) => {
                                        return (
                                          total +
                                          (dataNilaiVerifikasi.skor || 0)
                                        )
                                      },
                                      0
                                    )}
                                  </td>
                                  <td className="px-2 py-1 border text-center">
                                    <Button
                                      variant={"outline"}
                                      disabled={isPendingSaveMultiple}
                                      onClick={() => handleSaveMultiple("A")}
                                    >
                                      {isPendingSaveMultiple ? (
                                        <>
                                          <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                                          Processing...
                                        </>
                                      ) : (
                                        "Simpan Semua"
                                      )}
                                    </Button>
                                  </td>
                                </tr>
                              </tfoot>
                            </>
                          ) : (
                            ""
                          )}

                          {key === "B" ? (
                            <>
                              <tbody>
                                <tr>
                                  <td className="px-2 py-1 border text-center font-medium">
                                    No
                                  </td>
                                  <td className="px-2 py-1 border font-medium">
                                    Jenis Pengalaman
                                  </td>
                                  <td className="px-2 py-1 border text-center font-medium">
                                    Jumlah Lokal (bobot = 5)
                                  </td>
                                  <td className="px-2 py-1 border text-center font-medium">
                                    Jumlah Nasional (bobot = 7)
                                  </td>
                                  <td className="px-2 py-1 border text-center font-medium">
                                    Jumlah Internasional (bobot = 10)
                                  </td>
                                  <td className="px-2 py-1 border text-center font-medium">
                                    Skor = Σ (Bobot * Jumlah)
                                  </td>
                                </tr>
                                {listDataPenilaian[key]?.map(
                                  (
                                    dataNilaiVerifikasi: DataNilaiVerifikasiPasca,
                                    index: number
                                  ) => {
                                    const bobotLokal =
                                      listDataPenilaian[key]
                                        .find(
                                          (item: DataNilaiVerifikasiPasca) =>
                                            item.komponen_penilaian?.parent_komponen?.bobot_komponen_karyatulis?.find(
                                              (bobot) =>
                                                bobot.tingkat?.startsWith(
                                                  "Lokal"
                                                )
                                            )
                                        )
                                        ?.komponen_penilaian?.parent_komponen?.bobot_komponen_karyatulis?.find(
                                          (bobot: BobotKomponenKaryatulis) =>
                                            bobot.tingkat?.startsWith("Lokal")
                                        )?.bobot ?? 0

                                    const bobotNasional =
                                      listDataPenilaian[key]
                                        .find(
                                          (item: DataNilaiVerifikasiPasca) =>
                                            item.komponen_penilaian?.parent_komponen?.bobot_komponen_karyatulis?.find(
                                              (bobot) =>
                                                bobot.tingkat?.startsWith(
                                                  "Nasional"
                                                )
                                            )
                                        )
                                        ?.komponen_penilaian?.parent_komponen?.bobot_komponen_karyatulis?.find(
                                          (bobot: BobotKomponenKaryatulis) =>
                                            bobot.tingkat?.startsWith(
                                              "Nasional"
                                            )
                                        )?.bobot ?? 0

                                    const bobotInternasional =
                                      listDataPenilaian[key]
                                        .find(
                                          (item: DataNilaiVerifikasiPasca) =>
                                            item.komponen_penilaian?.parent_komponen?.bobot_komponen_karyatulis?.find(
                                              (bobot) =>
                                                bobot.tingkat?.startsWith(
                                                  "Internasional"
                                                )
                                            )
                                        )
                                        ?.komponen_penilaian?.parent_komponen?.bobot_komponen_karyatulis?.find(
                                          (bobot: BobotKomponenKaryatulis) =>
                                            bobot.tingkat?.startsWith(
                                              "Internasional"
                                            )
                                        )?.bobot ?? 0

                                    const skorLokal =
                                      (dataNilaiVerifikasi?.jumlah_lokal ?? 0) *
                                      bobotLokal
                                    const skorNasional =
                                      (dataNilaiVerifikasi?.jumlah_nasional ??
                                        0) * bobotNasional
                                    const skorInternasional =
                                      (dataNilaiVerifikasi?.jumlah_internasional ??
                                        0) * bobotInternasional

                                    const isSaving =
                                      isPending &&
                                      savingDataNilaiVerifikasi?.id_ref_komponen_penilaian_pasca ==
                                        dataNilaiVerifikasi.id_ref_komponen_penilaian_pasca

                                    return (
                                      <tr key={index}>
                                        <td className="px-2 py-1 border text-center">
                                          {index + 1}
                                        </td>
                                        <td className="px-2 py-1 border">
                                          {
                                            dataNilaiVerifikasi
                                              .komponen_penilaian?.nama_komponen
                                          }
                                        </td>
                                        <td className="px-2 py-1 border text-center">
                                          <Input
                                            type="number"
                                            placeholder="Ketik jumlah lokal..."
                                            value={
                                              jumlahData[index]?.jumlah_lokal ||
                                              "0"
                                            }
                                            onChange={(e) =>
                                              handleInputChange(
                                                dataNilaiVerifikasi.id_ref_komponen_penilaian_pasca,
                                                Number(e.target.value),
                                                "jumlah_lokal",
                                                index
                                              )
                                            }
                                          />
                                        </td>
                                        <td className="px-2 py-1 border text-center">
                                          <Input
                                            type="number"
                                            placeholder="Ketik jumlah nasional..."
                                            value={
                                              jumlahData[index]
                                                ?.jumlah_nasional || "0"
                                            }
                                            onChange={(e) =>
                                              handleInputChange(
                                                dataNilaiVerifikasi.id_ref_komponen_penilaian_pasca,
                                                Number(e.target.value),
                                                "jumlah_nasional",
                                                index
                                              )
                                            }
                                          />
                                        </td>
                                        <td className="px-2 py-1 border text-center">
                                          <Input
                                            type="number"
                                            placeholder="Ketik jumlah internasional..."
                                            value={
                                              jumlahData[index]
                                                ?.jumlah_internasional || "0"
                                            }
                                            onChange={(e) =>
                                              handleInputChange(
                                                dataNilaiVerifikasi.id_ref_komponen_penilaian_pasca,
                                                Number(e.target.value),
                                                "jumlah_internasional",
                                                index
                                              )
                                            }
                                          />
                                        </td>
                                        <td className="px-2 py-1 border text-center">
                                          {skorLokal +
                                            skorNasional +
                                            skorInternasional}
                                        </td>
                                        <td className="px-2 py-1 border text-center">
                                          <Button
                                            variant={"outline"}
                                            disabled={isSaving}
                                            onClick={() =>
                                              handleSave(
                                                dataNilaiVerifikasi,
                                                index,
                                                "B"
                                              )
                                            }
                                          >
                                            {isSaving ? (
                                              <>
                                                <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                                                Processing...
                                              </>
                                            ) : (
                                              "Simpan"
                                            )}
                                          </Button>
                                        </td>
                                      </tr>
                                    )
                                  }
                                )}
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td
                                    className="px-2 py-1 border text-center"
                                    colSpan={5}
                                  >
                                    Total
                                  </td>
                                  <td className="px-2 py-1 border text-center">
                                    {listDataPenilaian[key]?.reduce(
                                      (
                                        total: number,
                                        dataNilaiVerifikasi: DataNilaiVerifikasiPasca
                                      ) => {
                                        return (
                                          total +
                                          (dataNilaiVerifikasi.skor || 0)
                                        )
                                      },
                                      0
                                    )}
                                  </td>
                                  <td className="px-2 py-1 border text-center">
                                    <Button
                                      variant={"outline"}
                                      disabled={isPendingSaveMultiple}
                                      onClick={() => handleSaveMultiple("B")}
                                    >
                                      {isPendingSaveMultiple ? (
                                        <>
                                          <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                                          Processing...
                                        </>
                                      ) : (
                                        "Simpan Semua"
                                      )}
                                    </Button>
                                  </td>
                                </tr>
                              </tfoot>
                            </>
                          ) : (
                            ""
                          )}

                          {key === "C" ? (
                            <>
                              <tr>
                                <td className="px-2 py-1 border text-center font-semibold">
                                  No
                                </td>
                                <td
                                  className="px-2 py-1 borde font-semibold"
                                  colSpan={4}
                                >
                                  Jenis Tes
                                </td>
                                <td className="px-2 py-1 border text-center font-semibold">
                                  Skor
                                </td>
                                <td className="px-2 py-1 border text-center font-semibold"></td>
                              </tr>
                              {listDataPenilaian[key]?.map(
                                (
                                  dataNilaiVerifikasi: DataNilaiVerifikasiPasca,
                                  index: number
                                ) => {
                                  return (
                                    <tr>
                                      <td className="px-2 py-1 border text-center">
                                        {index + 1}
                                      </td>
                                      <td
                                        className="px-2 py-1 border"
                                        colSpan={4}
                                      >
                                        {
                                          dataNilaiVerifikasi.komponen_penilaian
                                            ?.nama_komponen
                                        }
                                      </td>
                                      <td className="px-2 py-1 border text-center">
                                        {dataNilaiVerifikasi?.skor}
                                      </td>
                                    </tr>
                                  )
                                }
                              )}
                            </>
                          ) : (
                            ""
                          )}
                        </table>
                      </div>
                    )
                  })
                : ""}
            </div>
          )}
        </section>
      </div>
    </div>
  )
}
